import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTaxCodeForm from "../../forms/CreateOrUpdateTaxCodeForm";
import { TaxCodeResponseDto } from "../../shared/dtos/taxCode/TaxCodeResponseDto";

interface UpdateTaxCodeModalProps {
  open: boolean;
  onClose: () => void;
  taxCode: TaxCodeResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateTaxCodeModal: React.FC<UpdateTaxCodeModalProps> = ({
  open,
  onClose,
  taxCode,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Tax Code: ${taxCode.name}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateTaxCodeForm
      isEditing={true}
      taxCode={taxCode}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateTaxCodeModal;
